import React, {useContext, useEffect, useState} from "react";
import "./Results.scss";
import PayTable from "./PayTable/PayTable";
import GameResults from "./GameResults/GameResults";
import {Context} from "../../App";
import {LAST_RESULTS_DATA} from "../../services/RequestDatas";
import RequestManager from "../../services/RequestManager";
import Utils from "../../utils/Utils";
import DeluxResults from "./DeluxResults/DeluxResults";

function Results({isClassicMode}) {
  const context = useContext(Context);
  const socket = RequestManager.getInstance().webSocket;
  const [resultsData, setResultsData] = useState();

  useEffect(() => {
    if (context.gamesData.get) {
      sendResultsRequest();
    }
  }, [context.gamesData.get]);

  const sendResultsRequest = () => {
    LAST_RESULTS_DATA.params.sport_id = context.gameID;
    socket.send(JSON.stringify(LAST_RESULTS_DATA));
    socket.addEventListener(
      RequestManager.LAST_RESULTS_EVENT,
      parseGameTimesData,
      {once: true}
    );
  };

  const parseGameTimesData = ({detail}) => {
    const results = detail?.data?.details;

    if (results) {
      setResultsData(results);

      if (results.latest_results[0]) {
        context.lastResultNumber.set(results.latest_results[0].number);
      }
      if (results.latest_suit_results) {
        context.lastResultSuit.set(results.latest_suit_results[0].number);
      }
    }
  };

  const getRoundID = () => {
    const gamesData = context.gamesData.get;
    const firstKey = Utils.lastKey(gamesData);

    return firstKey ? gamesData[firstKey]["round"] : "";
  };

  const drowResults = () => {
    if (isClassicMode) {
      return (
        <div className="results">
          <PayTable roundID={getRoundID()}/>
          {resultsData ? <GameResults results={resultsData}/> : null}
        </div>
      );
    }

    return <DeluxResults resultsData={resultsData} getRoundID={getRoundID()}/>;
  };

  return drowResults();
}

export default Results;
